// src/components/resources/tools/generators/GeneratorToolLoadingFallback.tsx

'use client'

import Link from 'next/link'
import { BrandedSpinner } from '~/components/ui/BrandedSpinner'

/**
 * Compact loading fallback for the interactive generator client chunk
 * (dynamic import + Suspense inside `GeneratorLayout`).
 */
export function GeneratorToolLoadingFallback(): JSX.Element {
  return (
    <div
      className="flex min-h-[400px] flex-col items-center justify-center gap-4 rounded-2xl border border-gray-200 bg-gray-50/50 px-6 py-12 text-center dark:border-gray-800 dark:bg-gray-900/30"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading interactive generator"
    >
      <BrandedSpinner size="lg" />
      <p className="max-w-md text-sm text-gray-600 dark:text-gray-400">
        Loading the interactive generator&hellip;
      </p>
      <p className="max-w-md text-xs text-gray-500 dark:text-gray-500">
        Free marketing generators for mockups, UTMs, personas, and creative assets.{' '}
        <Link
          href="/resources/tools/generators"
          className="font-medium text-primary underline-offset-2 hover:underline"
        >
          Browse all generators
        </Link>
      </p>
    </div>
  )
}
